import logo from "./logo"
import program from "./commander"
import {
  white,
  redBright,
  greenBright,
  yellowBright,
  blueBright,
  cyanBright,
} from "chalk"
import { ILogger } from "./types"
import { upSFX, downSFX } from "../sfx"

let prevPrice: number = 0

const locale = Intl.DateTimeFormat().resolvedOptions().locale

const logger: ILogger = {
  log: (id, price, currency, tokens, verbose) => {
    try {
      if (!price) return console.error("No price")

      const assets = price * tokens
      const timestring = new Date().toLocaleTimeString()
      const localePrice = getLocaleCurrency(price, locale, currency)
      const localeAssets = getLocaleCurrency(assets, locale, currency)

      let styled = {
        price: white(localePrice),
        assets: "",
      }

      if (assets)
        styled.assets = `${cyanBright("\xa0=>")} ${yellowBright(localeAssets)}`

      if (price > prevPrice) {
        upSFX()
        styled.price = greenBright(localePrice)
      }
      if (price < prevPrice) {
        downSFX()
        styled.price = redBright(localePrice)
      }

      if (price === prevPrice && !verbose) return

      const chalked = blueBright(
        `${id}: ${styled.price}${styled.assets} @ ${timestring}`
      )

      console.info(chalked)

      //Store previous price to compare it in the next call.
      prevPrice = price

      return
    } catch (err) {
      throw Error(err)
    }
  },
}

const getLocaleCurrency = (amount, locale, currency) => {
  return amount.toLocaleString(locale, {
    style: "currency",
    currency: currency,
    maximumFractionDigits: 8,
  })
}

const initMessage = () => {
  let msg = "\nIntialized with values: "
  Object.entries(program.opts()).forEach(
    ([key, val]) => (msg += `\n${blueBright(key)}:${cyanBright(val)}`)
  )
  console.info(msg)
  console.info(logo)
}

export { initMessage }
export default logger
